import React, { useMemo, useState } from 'react'
import VerticalNavBar from "../../../components/Navbar/PlatformNavBar/VerticalNavBar";
import { useSelector } from "react-redux";
import { Options } from './AdminData';
import UserTable from '../../../components/Admin/Tables/UserTable';
import VideosTable from '../../../components/Admin/Tables/VideosTable';
import LiveClasses from '../../../components/Admin/Tables/LiveClasses';
import SeriesTable from '../../../components/Admin/Tables/SeriesTable';
import SubscriptionTable from '../../../components/Admin/Tables/SubscriptionTable';
import MandalasTable from '../../../components/Admin/Tables/MandalasTable';
import PromotionPopupSettings from '../../../components/Admin/PromotionPopup/PromotionPopupSettings';

function getInitials(name = 'Admin') {
  const safeName = String(name || 'Admin').trim();
  const parts = safeName.split(' ').filter(Boolean);

  if (parts.length > 1) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }

  return (parts[0]?.[0] || 'A').toUpperCase();
}

const AdminPage = () => {
    const [selectOption,setSelectOption] = useState('Usuarios');
    const userId = useSelector((state) => state.user.currentUser);
    const userName = userId?.fullName || 'Administradora';
    const userEmail = userId?.email || 'admin@mujersoberana.com';

    const optionDescription = useMemo(() => {
      switch (selectOption) {
        case 'Usuarios':
          return 'Administra cuentas, acceso y estado de la comunidad.';
        case 'Media':
          return 'Gestiona videos, audios y PDFs en una sola tabla.';
        case 'Clases en Vivo':
          return 'Controla programación y estado de transmisiones activas.';
        case 'Retos':
          return 'Organiza y publica retos con seguimiento de progreso.';
        case 'Mandalas':
          return 'Mantén al día la biblioteca visual de mandalas.';
        case 'Subscripciones':
          return 'Supervisa planes, estado de pagos y membresías.';
        case 'Promotion Popup':
          return 'Configura el popup promocional y administra los correos recolectados.';
        default:
          return 'Gestiona la información del panel administrativo.';
      }
    }, [selectOption]);
    
    const handleOption =(option) =>{
      setSelectOption(option);
    }

    const getAdminTable =(option)=>{
      switch(option){
        case "Usuarios":
          return <UserTable></UserTable>
        case "Media":
          return <VideosTable mediaType="all" />
        case "Clases en Vivo":
          return <LiveClasses/>
        case "Retos":
          return <SeriesTable/>
        case "Mandalas":
          return <MandalasTable/>
        case "Subscripciones":
          return <SubscriptionTable/>
        case "Promotion Popup":
          return <PromotionPopupSettings />
        default:
          return <UserTable></UserTable>
      }
    }

  return (<>
      <section className="index-platform flex min-h-screen bg-[#f4f6f8]">
        <VerticalNavBar />
        <div className='w-full min-w-0'>
          <div className="sticky top-0 z-20 border-b border-[#d8ecee] bg-[#f4f6f8]/95 backdrop-blur px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex items-center justify-between gap-3">
              <div>
                <p className="text-[10px] sm:text-xs uppercase tracking-[0.22em] text-[#4a8285]">Mujer Soberana</p>
                <h1 className="font-['Playfair_Display'] text-xl sm:text-2xl text-[#070707]">Panel de Administración</h1>
              </div>
              <div className="flex items-center gap-3 rounded-2xl border border-[#d8ecee] bg-white px-3 py-2 shadow-sm">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-[#B14A36] to-[#E6A341] text-xs font-semibold text-white">
                  {getInitials(userName)}
                </div>
                <div className="hidden sm:block min-w-0">
                  <p className="truncate text-sm font-medium text-[#070707]">{userName}</p>
                  <p className="truncate text-xs text-[#6b7280]">{userEmail}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
            <div className="mb-6 rounded-2xl border border-[#b0d8dc] bg-white p-5 sm:p-6 shadow-[0_2px_16px_rgba(46,83,85,0.08)]">
              <p className="text-[10px] uppercase tracking-[0.24em] text-[#4a8285] mb-2">Centro de Control</p>
              <h2 className="font-['Playfair_Display'] text-2xl sm:text-3xl text-[#070707]">Gestión de contenido y usuarios</h2>
              <p className="mt-2 text-sm text-[#6b7280]">Selecciona un módulo para administrar recursos, membresías y configuración del ecosistema.</p>
            </div>

            <div className="mb-8">
              <h3 className="mb-4 text-sm uppercase tracking-[0.2em] text-[#6b7280]">Módulos</h3>
              <div id="top-function-dashboard" className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-5">
                {Options.map((option,index)=>{
                  const isActive = selectOption === option.title;

                  return (
                    <button
                      key={index}
                      onClick={() => handleOption(option.title)}
                      className={`group rounded-2xl border p-5 text-left transition-all duration-200 ${
                        isActive
                          ? 'border-[#B14A36] bg-[#fffbf5] shadow-[0_8px_24px_rgba(177,74,54,0.22)]'
                          : 'border-[#d8ecee] bg-white hover:-translate-y-0.5 hover:border-[#fbd495] hover:shadow-[0_6px_20px_rgba(46,83,85,0.14)]'
                      }`}
                    >
                      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-[#f4f6f8]">
                        <img className="h-7 w-7 object-contain" src={option.icon} alt={option.title} />
                      </div>
                      <h4 className={`text-base font-medium ${isActive ? 'text-[#B14A36]' : 'text-[#070707]'}`}>{option.title}</h4>
                      <p className="mt-1 text-xs text-[#6b7280]">Accede a la gestión de {option.title.toLowerCase()}.</p>
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="rounded-2xl border border-[#d8ecee] bg-white shadow-[0_2px_16px_rgba(46,83,85,0.08)]">
              <div className="border-b border-[#e5edf0] px-4 sm:px-6 py-4">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <div>
                    <h6 className="font-['Playfair_Display'] text-xl sm:text-2xl text-[#070707]">{selectOption}</h6>
                    <p className="mt-1 text-sm text-[#6b7280]">{optionDescription}</p>
                  </div>
                  <span className="inline-flex items-center rounded-full bg-[#d8ecee] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-[#2e5355]">
                    Activo
                  </span>
                </div>
              </div>

              <div className="px-3 sm:px-4 md:px-6 py-5 overflow-x-auto">
                {getAdminTable(selectOption)}
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}

export default AdminPage